export default "__VITE_ASSET__CxtgsD7r__"